import { type LinkProps, Link as RouterLink } from "react-router";

import { cn } from "@/lib/utils";

interface IProps {
  external?: boolean;
  noDecoration?: boolean;
}

export const Link: FC<IProps & LinkProps> = ({
  children,
  className,
  external,
  noDecoration,
  ref,
  ...linkProps
}) => {
  const isExternal = external || (linkProps.to && typeof linkProps.to === "string" && linkProps.to.startsWith("http"));
  const props = {
    className: cn(className, {
      "no-underline": noDecoration,
    }),
    ...linkProps,
  };

  const href = typeof linkProps.to === "string" ? linkProps.to : `${linkProps.to.pathname}${linkProps.to.search}`;
  return isExternal
    ? (
        <a href={href} ref={ref} {...props}>
          {children}
        </a>
      )
    : (
        <RouterLink ref={ref} {...props}>
          {children}
        </RouterLink>
      );
};
